import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Preloader from '../../components/common/Preloader';
import SEO from '../../components/common/SEO';
import superAdminApiClient from '../../api/superAdminApiClient';
import { toast } from 'react-toastify';
import './SuperAdminDashboard.css';

const Dashboard = () => {
    const [stats, setStats] = useState({
        totalPaidVendors: 0,
        totalTrialVendors: 0,
        totalFreeVendors: 0,
        totalSubmittedLeads: 0
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchStats();
    }, []);

    const fetchStats = async () => {
        try {
            const response = await superAdminApiClient.get('/superadmin/dashboard-stats');
            if (response.data.success) {
                setStats(response.data.stats);
            }
            setLoading(false);
        } catch (error) {
            console.error("Error fetching stats:", error);
            toast.error("Failed to fetch dashboard statistics");
            setLoading(false);
        }
    };

    const statCards = [
        {
            title: "Total Paid Vendors",
            count: stats.totalPaidVendors,
            icon: "ri-money-rupee-circle-fill",
            colorClass: "text-success",
            bgIcon: "bg-success-subtle",
            gradient: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
            link: "/superadmin/vendors/paid"
        },
        {
            title: "Trial Vendors",
            count: stats.totalTrialVendors,
            icon: "ri-timer-flash-fill",
            colorClass: "text-warning",
            bgIcon: "bg-warning-subtle",
            gradient: "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
            link: "/superadmin/vendors/trial"
        },
        {
            title: "Free Vendors",
            count: stats.totalFreeVendors,
            icon: "ri-user-smile-fill",
            colorClass: "text-info",
            bgIcon: "bg-info-subtle",
            gradient: "linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)",
            link: "/superadmin/vendors/free"
        },
        {
            title: "Total Submitted Leads",
            count: stats.totalSubmittedLeads,
            icon: "ri-file-list-3-fill",
            colorClass: "text-primary",
            bgIcon: "bg-primary-subtle",
            gradient: "linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)",
            link: "/superadmin/leads"
        }
    ];

    if (loading) {
        return <Preloader />;
    }

    return (
        <React.Fragment>
            <SEO
                title="Dashboard | Mangoloops Super Admin"
                description="Manage vendors, leads, and platform settings from the Mangoloops Super Admin Dashboard."
            />

            <div className="row">
                <div className="col-12">
                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                        <h4 className="mb-sm-0 fw-bold">Super Admin Dashboard</h4>
                    </div>
                </div>
            </div>

            <div className="row">
                {statCards.map((card, index) => (
                    <div className="col-xl-3 col-md-6 mb-4" key={index}>
                        <div className="card trending-card h-100">
                            <div className="decor-blob"></div>
                            <div className="card-body p-4" style={{ zIndex: 1, position: 'relative' }}>
                                <div className="d-flex align-items-center justify-content-between mb-4">
                                    <div className="trending-icon-box" style={{ background: card.gradient }}>
                                        <i className={card.icon}></i>
                                    </div>
                                    <div className="text-end">
                                        <p className="text-uppercase trending-title mb-1">
                                            {card.title}
                                        </p>
                                        <h4 className="trending-count mb-0">
                                            {loading ? <span className="spinner-border spinner-border-sm text-muted"></span> : card.count}
                                        </h4>
                                    </div>
                                </div>
                                <div className="mt-3 pt-3 border-top border-light d-flex align-items-center justify-content-between">
                                    <Link to={card.link} className={`trending-link ${card.colorClass}`}>
                                        View Details <i className="ri-arrow-right-line align-middle ms-1"></i>
                                    </Link>
                                    <div className="badge bg-light text-dark rounded-pill px-2 py-1 shadow-sm border border-light">
                                        <i className="ri-pulse-line text-success me-1"></i> Live
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <div className="row mt-4">
                <div className="col-12">
                    <div className="card">
                        <div className="card-body">
                            <h5 className="card-title mb-3">Welcome to Mangoloops Super Admin</h5>
                            <p className="text-muted">
                                From this dashboard, you can monitor key platform metrics, manage vendors, handle leads, and configure system settings.
                                Select a category from the sidebar to begin.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default Dashboard;
